<template>
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container stitcher-modal flex flex-items--start">
        <button class="ghost-button mar-top--xl mar-right--xl" @click="$emit('close')">
            <span class="x-icon x-icon--circle"></span>
          </button>
          <div class="flex-grow--1">
            <div class="modal-header">
              <h1>Log into Your Adobe Analytics</h1>
              <hr>
            </div>
            <div class="modal-body">
              <b-alert show dismissible class="error" v-if="error">{{error}}</b-alert>
              <input class="textfield" v-model="username" type="text" placeholder="username">
              <input class="textfield" v-model="secret" type="password" placeholder="secret">
            </div>
            <div class="modal-footer">
                <button class="ghost-button" @click="$emit('close')">Cancel</button>
                <button class="purple-button" @click='submit'>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import AnalyticsReport from '@/api/Analytics/AnalyticsReport.js'
export default {
  components: {
  },
  props: {
    message: {
      type: String
    }
  },
  data () {
    return {
      username: '',
      secret: '',
      error: ''
    }
  },
  methods: {
    submit () {
      this.error = ''
      this.isVaild()
      if (!this.error) {
        AnalyticsReport.saveAAConnection({ 'username': this.username, 'secret': this.secret })
          .then(response => {
            if (response.error) {
              this.error = response.error
            } else {
              AnalyticsReport.getAAConnection()
              this.$emit('close')
            }
          })
      }
    },
    isVaild () {
      if (!this.username) {
        this.error = 'username is required '
      }
      if (!this.secret) {
        this.error = this.error + ' secret is required'
      }
    }
  }
}
</script>
  <style scoped>
    .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 50%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
  }

  .modal-body {
    margin: 20px 0;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  </style>
